export const VtexWhitelistMethod = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  ALL: 'ALL',
});

export type VtexWhiteListPath = {
  path: string;
  enabled: boolean;
  isPublic: boolean;
  method: (typeof VtexWhitelistMethod)[];
};

export type Whitelist = {
  id: string;
  provider: 'vtex';
  config: {
    paths: VtexWhiteListPath[];
  };
  enabled: boolean;
  created_at?: Date;
  updated_at?: Date;
};
